import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'ServiceContentsRegistSnapshotModal',
  components: {
    Loading
  },
  data () {
    return {
      processing: false,

      // form
      inpSnapshotName: null,
      inpTag: null,
      inpVersionName: null,
      inpReleaseNote: null,
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      active: state => state.serviceContentsRegistSnapshotModal.active,
      serviceId: state => state.serviceContentsRegistSnapshotModal.serviceId,
      serviceContentsId: state => state.serviceContentsRegistSnapshotModal.targetId,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),

    // validate
    inpSnapshotNameIsValid () {
      return Validator.validText(this.inpSnapshotName)
    },
    inpTagIsValid () {
      return Validator.validText(this.inpTag)
    },
    inpVersionNameIsValid () {
      return Validator.validText(this.inpVersionName)
    },
    inpReleaseNoteIsValid () {
      return Validator.validText(this.inpReleaseNote)
    },
    formIsValid () {
      return this.inpSnapshotNameIsValid &&
        this.inpTagIsValid &&
        this.inpVersionNameIsValid &&
        this.inpReleaseNoteIsValid
    },
    disableConfirmButton () {
      return !this.formIsValid
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    },
    confirmAccepted: function (to) {
      // 登録
      if (this.confirmKey === 'submit') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      hide: 'serviceContentsRegistSnapshotModal/hide'
    }),

    init () {

    },

    confirmData () {
      if (!this.formIsValid) return
      this.showConfirm({
        key: 'submit',
        title: '',
        body: 'この内容でスナップショットを登録しますか？',
        acceptLabel: '登録'
      })
    },
    postData () {
      this.processing = true

      let parameters = {
        serviceUuid: this.serviceId,
        serviceContentsUuid: this.serviceContentsId,
        request: {
          snapshotName: this.inpSnapshotName,
          snapshotTag: this.inpTag,
          versionName: this.inpVersionName,
          releaseNote: this.inpReleaseNote
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceContentsSetting'],
        ['v1ServiceContentsSnapshotPost'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: 'スナップショットの登録',
              body: 'スナップショットを登録しました。'
            })

            this.closeModal()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}